import React, { forwardRef } from "react";
import PropTypes from "prop-types";

const LabelForm = forwardRef(({ label = "", labelClassName = "" }, ref) => {
  return (
    label && (
      <div
        ref={ref}
        className={
          labelClassName
            ? labelClassName
            : "text-primary font-bold text-[24px] not-italic"
        }
      >
        {label}
      </div>
    )
  );
});

LabelForm.propTypes = {
  label: PropTypes.string,
};

export default LabelForm;
